/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCasinoIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-casino"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M7.55 18.3Q7.55 18.3 7.94 18.3Q8.32 18.3 8.86 17.76Q9.4 17.23 9.4 16.45Q9.4 15.68 8.86 15.14Q8.32 14.6 7.55 14.6Q6.78 14.6 6.24 15.14Q5.7 15.68 5.7 16.45Q5.7 17.23 6.24 17.76Q6.78 18.3 7.55 18.3ZM7.55 9.4Q7.55 9.4 7.94 9.4Q8.32 9.4 8.86 8.86Q9.4 8.32 9.4 7.55Q9.4 6.78 8.86 6.24Q8.32 5.7 7.55 5.7Q6.78 5.7 6.24 6.24Q5.7 6.78 5.7 7.55Q5.7 8.32 6.24 8.86Q6.78 9.4 7.55 9.4ZM12 13.85Q12 13.85 12.39 13.85Q12.78 13.85 13.31 13.31Q13.85 12.78 13.85 12Q13.85 11.22 13.31 10.69Q12.78 10.15 12 10.15Q11.22 10.15 10.69 10.69Q10.15 11.22 10.15 12Q10.15 12.78 10.69 13.31Q11.22 13.85 12 13.85ZM16.43 18.3Q16.43 18.3 16.81 18.3Q17.2 18.3 17.74 17.76Q18.27 17.23 18.27 16.45Q18.27 15.68 17.74 15.14Q17.2 14.6 16.43 14.6Q15.65 14.6 15.11 15.14Q14.57 15.68 14.57 16.45Q14.57 17.23 15.11 17.76Q15.65 18.3 16.43 18.3ZM16.45 9.4Q16.45 9.4 16.84 9.4Q17.23 9.4 17.76 8.86Q18.3 8.32 18.3 7.55Q18.3 6.78 17.76 6.24Q17.23 5.7 16.45 5.7Q15.68 5.7 15.14 6.24Q14.6 6.78 14.6 7.55Q14.6 8.32 15.14 8.86Q15.68 9.4 16.45 9.4ZM5 21.65Q3.9 21.65 3.13 20.88Q2.35 20.1 2.35 19L2.35 5Q2.35 3.9 3.13 3.13Q3.9 2.35 5 2.35L19 2.35Q20.1 2.35 20.88 3.13Q21.65 3.9 21.65 5L21.65 19Q21.65 20.1 20.88 20.88Q20.1 21.65 19 21.65Z" fill={color} />
    </svg>
  );
}
